import React, { memo } from 'react';
export const ProblemSection = memo(function ProblemSection() {
  const problems = [{
    icon: '💸',
    text: 'Pagaste una fortuna por una visita de 20 minutos para un arreglo simple.'
  }, {
    icon: '😤',
    text: 'Sabés que es fácil, pero sin la info correcta preferís no arriesgarte.'
  }, {
    icon: '⏳',
    text: 'Perdés tiempo y plata esperando un técnico por algo que resolverías solo en minutos.'
  }];
  return <section className="py-12 px-4 bg-gray-900" data-id="element-156">
      <div className="max-w-2xl mx-auto" data-id="element-157">
        {/* PROBLEMA */}
        <h2 className="text-[22px] md:text-3xl font-black text-white leading-tight text-center mb-6" data-id="element-158">
          ¿Te sentís identificado con{' '}
          <span className="text-blue-500" data-id="element-159">alguna de estas?</span>
        </h2>

        <div className="space-y-3 mb-6" data-id="element-160">
          {problems.map((p, i) => <div key={i} className="flex items-center gap-4 bg-gray-800 border border-gray-700 rounded-xl px-5 py-4" data-id="element-161">
              <span className="text-2xl flex-shrink-0" data-id="element-162">{p.icon}</span>
              <p className="text-white font-bold text-[14px] md:text-base leading-snug" data-id="element-163">
                {p.text}
              </p>
            </div>)}
        </div>

        {/* PUENTE + SOLUCIÓN en un solo bloque */}
        <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl px-5 py-6 text-center" data-id="element-164">
          <div className="inline-block px-4 py-1 rounded-full font-bold text-xs mb-3 text-blue-400 bg-blue-500/10 border border-blue-500/30 uppercase tracking-widest" data-id="element-165">
            ⚡ La Solución
          </div>
          <h3 className="text-[20px] md:text-3xl font-black text-blue-500 mb-2" data-id="element-166">
            MEGAPACK ELECTRICISTA EN CASA
          </h3>
          <p className="text-white/80 font-bold text-[13px] md:text-base leading-snug mb-4" data-id="element-167">
            El método paso a paso para resolver los problemas eléctricos de tu
            hogar vos mismo, sin miedo, sin técnicos y sin gastar de más.
          </p>
          <div className="grid grid-cols-2 gap-2" data-id="element-168">
            {[{
            icon: '📚',
            text: '6 Tomos paso a paso'
          }, {
            icon: '🔧',
            text: 'Sin conocimientos previos'
          }, {
            icon: '💰',
            text: 'Ahorrás desde el día 1'
          }, {
            icon: '🛡️',
            text: 'Con total seguridad'
          }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-gray-900/60 rounded-lg px-3 py-2" data-id="element-169">
                <span className="text-lg" data-id="element-170">{item.icon}</span>
                <p className="text-white font-bold text-[12px] md:text-sm leading-tight" data-id="element-171">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
});